import { render } from "./Investments.vue?vue&type=template&id=86ac3d60"
import script from "./Investments.vue?vue&type=script&lang=js"
export * from "./Investments.vue?vue&type=script&lang=js"

import "./Investments.vue?vue&type=style&index=0&id=86ac3d60&lang=scss"

import exportComponent from "/var/www/prod.storm.ms/actions-runner/storm-site/storm-site/storm-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__